import React from "react";
import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div className="container-x py-24 text-center" data-testid="not-found">
      <div className="font-serif text-8xl gold-text">404</div>
      <div className="font-serif text-3xl mt-4">Page not found</div>
      <p className="text-sm text-muted-foreground mt-2">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="mt-8 inline-block btn-gold rounded-full px-8 py-3 text-xs uppercase tracking-widest">Return Home</Link>
    </div>
  );
}
